  export default function () {
      return [{
              name: 'Home',
              link: '/'
          },
          {
              name: 'News',
              link: '/news'
          },
          {
              name: 'Profile',
              link: '/profile'
          },
          {
              name: 'Login',
              link: '/login'
          }
      ]
  }